import { SketchObjectType } from '../sketch-object';
import { type LibItem } from './common';

export const saturation: LibItem = {
  id: Math.random() * 100000,
  thumbUrl: '/assets/images/sketch-tool/saturation.svg',
  name: 'Saturation',
  type: SketchObjectType.Image,
  src: '/assets/images/sketch-tool/saturation.svg',
  width: 48,
  height: 48,
};
